module.exports = __webpack_public_path__ + "static/media/button-download-blue.4ee0b09e.svg";